import { toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import ClearIcon from '@mui/icons-material/Clear';
import React, { useEffect, useState } from "react";
import { isEmpty } from "../../utils/isObjectEmpty";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../components/Spinner/Spinner";
import LoaderIcon from "../../components/loader/Loader";
import { Select, InputLabel, MenuItem, TextField, Button } from "@mui/material";
import { getAvailableCourses, getAvailableExams } from "../../redux/students/studentsSlice";
import { getConfigDetails, updateConfigDetail } from "../../redux/configurationDetails/configDetailsSlice";

const useStyles = makeStyles( theme => ({
    topHeading: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    topHeader: {
        marginBottom: 24,
        fontSize: '34px',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    formInputLabel:{
        color: '#000 !important',
        fontSize: '18px !important',
        marginBottom: '4px',
        fontWeight: 'bold !important'
    },
    marginBot24: {
        marginBottom: '24px'
    },
}))

const ConfigList = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [cityList, setCityList] = useState({});
    const [cityValue, setCityValue] = useState("");
    const [configData, setConfigData] = useState([]);
    const [countryValue, setCountryValue] = useState("");
    const [categoryInfo, setCategoryInfo] = useState({});
    const [selectedExam, setSelectedExam] = useState("");
    const [submitLoader, setSubmitLoader] = useState(false);
    const [courseOrDegree, setCourseOrDegree] = useState("");
    const [availableExams, setAvailableExams] = useState({});
    const [countryLoader, setCountryLoader] = useState(false);
    const [formInformation, setFormInformation] = useState({});
    const [subCategoryValue, setSubCategoryValue] = useState("");
    const [availableCourses, setAvailableCourses] = useState({});
    const [coachingCityValue, setCoachingCityValue] = useState("");
    const [cityValueCoachingCat, setCityValueCoachingCat] = useState("");
    
    const { 
        isError,
        message,
        isLoading } = useSelector((state) => state.students);
    
    useEffect(() => {
        const res = dispatch(getAvailableCourses({limit: 100, offset: 0}));
        res?.then((r) => {
            if(r?.payload?.statusCode === 200){
                setAvailableCourses(r?.payload?.data?.result);
            }
        })
    }, [dispatch])

    useEffect(() => {
        const res = dispatch(getAvailableExams({limit: 100, offset: 0}));
        res?.then((r) => {
            if(r?.payload?.statusCode === 200){
                setAvailableExams(r?.payload?.data?.result);
            }
        })
    }, [dispatch])

    const handleChange = (event) => {
        
        if(event.target.name === "config-type"){
            const selectedConfig = configData.filter((item) => item._id === event.target.value)
            if(selectedConfig && selectedConfig?.length > 0){
                setFormInformation(selectedConfig[0]);
            }
        }
        if(event.target.name === "country"){
            const selectedCountry = formInformation?.data?.filter((item) => item.country === event.target.value)
            setCityList(selectedCountry[0]);
        }
        if(event.target.name === "category"){
            const selectedCategory = formInformation?.data?.filter((item) => item.cat === event.target.value)
            setCategoryInfo(selectedCategory[0]);
        }
        if(event.target.name === "city-co"){
            setCityValueCoachingCat(event.target.value);
        }
        if(event.target.name === "degree"){
            setCourseOrDegree(event.target.value);
        }
        if(event.target.name === "exam"){
            setSelectedExam(event.target.value);
        }
    };

    const submit = (type) => {
        if(type === "country"){
            if(!countryValue || countryValue === ""){
                toast.error("Country Name Required");
                return;
            }
            const country = formInformation?.data?.filter((item) => item.country === countryValue);
            if(country && country?.length > 0){
                toast.error("Country Already Present");
                return;
            }

            setFormInformation({
                ...formInformation,
                data: [
                    ...formInformation.data,
                    {country: countryValue, city: []}
                ]
            })
            const body = {
                ...formInformation,
                data: [
                    ...formInformation.data,
                    {country: countryValue, city: []}
                ]
            }
            setCountryLoader(true);
            const res = dispatch(updateConfigDetail({id: formInformation?._id, body}));
            res?.then((r) => {
                setCountryLoader(false);
                if(r?.payload?.statusCode === 200){
                    getAllConfiguration();
                    setCountryValue("");
                    toast.success("Country Added Successfuly");
                    return;
                }
                toast.error(r?.payload);
            })
        }
        if(type === "city"){
            const body = {
                configuration_type: formInformation?.configuration_type,
                data: formInformation?.data?.map((item) => item.country === cityList.country ? { ...item, city: cityList?.city } : item)
            }
            setSubmitLoader(true);
            const res = dispatch(updateConfigDetail({id: formInformation?._id, body}));
            res?.then((r) => {
                setSubmitLoader(false);
                if(r?.payload?.statusCode === 200){
                    toast.success("City Updated Successfuly");
                    return;
                }
                toast.error(r?.payload);
            })
        }
        if(type === "category"){
            const body = {
                configuration_type: formInformation?.configuration_type,
                data: formInformation?.data?.map((item) => item.cat === categoryInfo.cat ? { ...categoryInfo } : item)
            }
            setSubmitLoader(true);
            const res = dispatch(updateConfigDetail({id: formInformation?._id, body}));
            res?.then((r) => {
                setSubmitLoader(false);
                if(r?.payload?.statusCode === 200){
                    toast.success("Category Updated Successfuly");
                    return;
                }
                toast.error(r?.payload);
            })
        }
        if(type === "coaching_category"){
            const body = {
                configuration_type: formInformation?.configuration_type,
                data: formInformation?.data?.map((item) => item.cat === categoryInfo.cat ? { ...categoryInfo } : item)
            }
            setSubmitLoader(true);
            const res = dispatch(updateConfigDetail({id: formInformation?._id, body}));
            res?.then((r) => {
                setSubmitLoader(false);
                if(r?.payload?.statusCode === 200){
                    toast.success("Category Updated Successfuly");
                    return;
                }
                toast.error(r?.payload);
            })
        }
        if(type === "coaching_city"){
            // if(coachingCityValue === ""){
            //     toast.error("Enter City To Update");
            //     return;
            // }
            let array = [...formInformation?.data];
            const isCityPresent =  array?.filter((item) => item === coachingCityValue);
            if(isCityPresent && isCityPresent?.length > 0){
                toast.error("City Already Present");
                return;
            }
            coachingCityValue !== "" && array.push(coachingCityValue);
            const body = {
                configuration_type: formInformation?.configuration_type,
                data: [...array]
            }
            setSubmitLoader(true);
            const res = dispatch(updateConfigDetail({id: formInformation?._id, body}));
            res?.then((r) => {
                setSubmitLoader(false);
                if(r?.payload?.statusCode === 200){
                    getAllConfiguration();
                    setCoachingCityValue("");
                    toast.success("Coaching City Updated Successfuly");
                    return;
                }
                toast.error(r?.payload);
            })
        }
    }
  
    useEffect(() => { getAllConfiguration() }, [])

    const getAllConfiguration = () => {
        const res = dispatch(getConfigDetails());
        res.then((r) => {
            if(r?.payload?.data){ setConfigData([...r?.payload?.data]) }
        })
    }

    const removeCity = (city) => {
        const newList = cityList.city.filter((item) => item !== city);
        setCityList({...cityList, city: newList});
    }

    const addNewCity = () => {
        if(cityValue === ""){
            toast.error("Enter City To Update");
            return;
        }
        let array = [...cityList.city];
        const city = array.filter((item) => item === cityValue);

        if(city && city?.length > 0){
            toast.error("City Already Present");
            return;
        }
        array.push(cityValue);
        setCityList({...cityList, city: array});
        setCityValue("");
    }

    const addNewInCategory = (type) => {
        if(type === "city"){
            if(cityValue === ""){
                toast.error("Enter City To Update");
                return;
            }
            let array = categoryInfo?.city;
            const isData = array.filter((item) => item === cityValue);
            if(isData && isData?.length > 0){
                toast.error("City Already Present");
                return;
            }
            array.push(cityValue);
            setCategoryInfo({...categoryInfo, city: [...array]});
            setCityValue("");
        }
        if(type === "subcateory"){
            if(subCategoryValue === ""){
                toast.error("Enter Sub Category To Update");
                return;
            }
            let array = categoryInfo?.subCat;
            const isData = array.filter((item) => item === subCategoryValue);
            if(isData && isData?.length > 0){
                toast.error("Sub Category Already Present");
                return;
            }
            array.push(subCategoryValue);
            setCategoryInfo({...categoryInfo, subCat: [...array]});
            setSubCategoryValue("");
        }
        if(type === "degree"){
            if(courseOrDegree === ""){
                toast.error("Select A Degree Or Course To Update");
                return;
            }
            let array = categoryInfo?.degree;
            const isData = array.filter((item) => item === courseOrDegree);
            if(isData && isData?.length > 0){
                toast.error("Sub Category Already Present");
                return;
            }
            array.push(courseOrDegree);
            setCategoryInfo({...categoryInfo, degree: [...array]});
            setCourseOrDegree("");
        }
        if(type === "city-co"){
            if(cityValueCoachingCat === ""){
                toast.error("Select City To Update");
                return;
            }
            let array = [...categoryInfo?.city];
            const isData = array.filter((item) => item === cityValueCoachingCat);
            if(isData && isData?.length > 0){
                toast.error("City Already Present");
                return;
            }
            array.push(cityValueCoachingCat);
            setCategoryInfo({...categoryInfo, city: [...array]});
            setCityValueCoachingCat("");
        }
        if(type === "exam"){
            if(selectedExam === ""){
                toast.error("Select An Exam To Update");
                return;
            }
            let array = categoryInfo?.exams;
            const isData = array.filter((item) => item === selectedExam);
            if(isData && isData?.length > 0){
                toast.error("Exam Already Present");
                return;
            }
            array.push(selectedExam);
            setCategoryInfo({...categoryInfo, exams: [...array]});
            setSelectedExam("");
        }
    }
    
    const removeCategoryInfo = (item, type) => {
        if(type === "city"){
            let array = categoryInfo?.city;
            const newArray = array.filter((city) => city !== item);
            setCategoryInfo({...categoryInfo, city: [...newArray]});
        }
        if(type === "subcateory"){
            let array = categoryInfo?.subCat;
            const newArray = array.filter((category) => category !== item);
            setCategoryInfo({...categoryInfo, subCat: [...newArray]});
        }
        if(type === "degree"){
            let array = categoryInfo?.degree;
            const newArray = array.filter((degree) => degree !== item);
            setCategoryInfo({...categoryInfo, degree: [...newArray]});
        }
        if(type === "city-co"){
            let array = categoryInfo?.city;
            const newArray = array.filter((city) => city !== item);
            setCategoryInfo({...categoryInfo, city: [...newArray]});
        }
        if(type === "coaching-city"){
            let array = formInformation?.data;
            const newArray = array.filter((city) => city !== item);
            setFormInformation({...formInformation, data: [...newArray]});
        }
        if(type === "exam"){
            let array = categoryInfo?.exams;
            const newArray = array.filter((exam) => exam !== item);
            setCategoryInfo({...categoryInfo, exams: [...newArray]});
        }
    }

    const handleInputChange = (e) => {
        e.target.name === "new-country" && setCountryValue(e.target.value);
        e.target.name === "new-city" && setCityValue(e.target.value);
        e.target.name === "sub-category" && setSubCategoryValue(e.target.value);
        e.target.name === "new-city-co" && setCityValueCoachingCat(e.target.value);
        e.target.name === "new-coaching-city" && setCoachingCityValue(e.target.value);
    }

    if (isLoading) return <Spinner />;

    if (isError) return <h1 style={{ color: "red" }}>{message}</h1>;
  
    return (
        <div style={{ marginTop: '5%' }}>
            <div
                style={{
                    width: '100%',
                    marginRight: '12px',
                    position: 'relative',
                }}
            >
                <InputLabel className={classes.formInputLabel}>
                    Select Configuration To Change
                </InputLabel>
                <Select
                    sx={{
                        width: '100%',
                        border: 'none',
                        height: '56px',
                        marginRight: '12px',
                        position: 'relative',
                        textTransform: 'capitalize'
                    }}
                    displayEmpty
                    name="config-type"
                    onChange={handleChange}
                    className="select-class"
                    value={formInformation?._id ? formInformation?._id : ""}
                >
                    <MenuItem value="">
                        Select Configuration
                    </MenuItem>
                    {configData && configData.map((item, index) => (
                        <MenuItem
                            key={index}
                            value={item?._id}
                            sx={{textTransform: 'capitalize'}}
                        >
                            {item?.configuration_type === "city" ? "Coaching City" : 
                                item?.configuration_type.replace(/_/g, " ")}
                        </MenuItem>
                    ))}
                </Select>
            </div>
            {formInformation?.configuration_type === "university_countries" &&
                <>
                    <div 
                        style={{
                            padding: '12px',
                            marginTop: '16px',
                            border: '1px solid',
                            borderRadius: '4px'
                        }}
                    >
                        <InputLabel className={classes.formInputLabel}>
                            Add New Country
                        </InputLabel>
                        <div 
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <TextField
                                type="text"
                                name="new-country"
                                variant="outlined"
                                sx={{
                                    width: '78%',
                                    height: '62px'
                                }}
                                value={countryValue}
                                onChange={handleInputChange}
                            />
                            <Button
                                sx={{
                                    width: '20%',
                                    height: '56px',
                                    marginBottom: '12px',
                                    backgroundColor: 'var(--primary-color)',
                                    '&:hover': { backgroundColor: 'var(--primary-color)' }
                                }}
                                variant="contained"
                                disabled={countryLoader}
                                onClick={() => submit("country")}
                            >
                                {countryLoader ? <LoaderIcon />  : 'Submit' }
                            </Button>
                        </div>
                    </div>
                    <div
                        style={{
                            width: '100%',
                            marginTop: '12px',
                            marginRight: '12px',
                            position: 'relative',
                        }}
                    >
                        <InputLabel className={classes.formInputLabel}>
                            Select Country
                        </InputLabel>
                        <Select
                            sx={{
                                width: '100%',
                                border: 'none',
                                height: '56px',
                                marginRight: '12px',
                                position: 'relative',
                                textTransform: 'capitalize'
                            }}
                            displayEmpty
                            name="country"
                            onChange={handleChange}
                            className="select-class"
                            // value={formInformation?.information?.country}
                        >
                            <MenuItem value="">
                                Select Country
                            </MenuItem>
                            {formInformation.data.map((item, index) => (
                                <MenuItem
                                    value={item?.country}
                                    key={`${index}${item?.country}`}
                                    sx={{textTransform: 'capitalize'}}
                                >
                                    {item?.country}
                                </MenuItem>
                            ))}
                        </Select>
                        <div
                            style={{
                                padding: '12px',
                                marginTop: '16px',
                                border: '1px solid',
                                borderRadius: '4px'
                            }}
                        >
                            <InputLabel className={classes.formInputLabel}>
                                Add New City
                            </InputLabel>
                            <div 
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <TextField
                                    type="text"
                                    name="new-city"
                                    variant="outlined"
                                    sx={{
                                        width: '78%',
                                        height: '62px'
                                    }}
                                    value={cityValue}
                                    onChange={handleInputChange}
                                />
                                <Button
                                    sx={{
                                        width: '20%',
                                        height: '56px',
                                        marginBottom: '12px',
                                        backgroundColor: 'var(--primary-color)',
                                        '&:hover': { backgroundColor: 'var(--primary-color)' }
                                    }}
                                    variant="contained"
                                    onClick={addNewCity}
                                >
                                    Add City
                                </Button>
                            </div>
                        </div>
                        {cityList && cityList?.city?.length > 0 &&
                            cityList?.city?.map((item, index) => (
                                <div
                                    key={index}
                                    style={{ display: 'inline-block' }}
                                >
                                    <div 
                                        style={{
                                            display: 'flex',
                                            marginRight: '12px',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <p>{item}</p>
                                        <button
                                            type="button"
                                            style={{
                                                border: 'none',
                                                display: 'flex',
                                                cursor: 'pointer',
                                                background: 'none'
                                                
                                            }}
                                            onClick={() => removeCity(item)}
                                        >    
                                            <ClearIcon sx={{ fontSize: '20px' }}/>
                                        </button>
                                    </div>
                                </div>
                            ))
                        }
                        <Button
                            sx={{
                                width: '20%',
                                height: '56px',
                                display: 'flex',
                                marginTop: '8px',
                                marginBottom: '12px',
                                backgroundColor: 'var(--primary-color)',
                                '&:hover': { backgroundColor: 'var(--primary-color)' }
                            }}
                            variant="contained"
                            disabled={submitLoader}
                            onClick={() => submit("city")}
                        >
                            {submitLoader ? <LoaderIcon />  : 'Submit' }
                        </Button>
                    </div>
                </>
            }
            {formInformation?.configuration_type === "university_category" &&
                <>
                    <div
                        style={{
                            width: '100%',
                            marginTop: '12px',
                            marginRight: '12px',
                            position: 'relative',
                        }}
                    >
                        <InputLabel className={classes.formInputLabel}>
                            Select Category
                        </InputLabel>
                        <Select
                            sx={{
                                width: '100%',
                                border: 'none',
                                height: '56px',
                                marginRight: '12px',
                                position: 'relative',
                                textTransform: 'capitalize'
                            }}
                            displayEmpty
                            name="category"
                            onChange={handleChange}
                            className="select-class"
                            value={categoryInfo?.cat}
                        >
                            <MenuItem value="">
                                Select Category
                            </MenuItem>
                            {formInformation.data.map((item, index) => (
                                <MenuItem
                                    value={item?.cat}
                                    key={`${index}${item?.cat}`}
                                    sx={{textTransform: 'capitalize'}}
                                >
                                    {item?.cat}
                                </MenuItem>
                            ))}
                        </Select>
                        {!isEmpty(categoryInfo) &&
                            <>
                                <div
                                    style={{
                                        padding: '12px',
                                        marginTop: '16px',
                                        border: '1px solid',
                                        borderRadius: '4px'
                                    }}
                                >
                                    <InputLabel className={classes.formInputLabel}>
                                        Add New City
                                    </InputLabel>
                                    <div 
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <TextField
                                            type="text"
                                            name="new-city"
                                            variant="outlined"
                                            sx={{
                                                width: '78%',
                                                height: '62px'
                                            }}
                                            value={cityValue}
                                            onChange={handleInputChange}
                                        />
                                        <Button
                                            sx={{
                                                width: '20%',
                                                height: '56px',
                                                marginBottom: '12px',
                                                backgroundColor: 'var(--primary-color)',
                                                '&:hover': { backgroundColor: 'var(--primary-color)' }
                                            }}
                                            variant="contained"
                                            onClick={() => addNewInCategory("city")}
                                        >
                                            Add City
                                        </Button>
                                    </div>
                                    {categoryInfo?.city && categoryInfo?.city?.length > 0 &&
                                        categoryInfo?.city?.map((item, index) => (
                                            <div
                                                key={index}
                                                style={{ display: 'inline-block' }}
                                            >
                                                <div 
                                                    style={{
                                                        display: 'flex',
                                                        marginRight: '12px',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <p>{item}</p>
                                                    <button
                                                        type="button"
                                                        style={{
                                                            border: 'none',
                                                            display: 'flex',
                                                            cursor: 'pointer',
                                                            background: 'none'
                                                            
                                                        }}
                                                        onClick={() => removeCategoryInfo(item, "city")}
                                                    >    
                                                        <ClearIcon sx={{ fontSize: '20px' }}/>
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                                <div
                                    style={{
                                        padding: '12px',
                                        marginTop: '16px',
                                        border: '1px solid',
                                        borderRadius: '4px'
                                    }}
                                >
                                    <InputLabel className={classes.formInputLabel}>
                                        Add New Sub Category
                                    </InputLabel>
                                    <div 
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <TextField
                                            type="text"
                                            name="sub-category"
                                            variant="outlined"
                                            sx={{
                                                width: '78%',
                                                height: '62px'
                                            }}
                                            value={subCategoryValue}
                                            onChange={handleInputChange}
                                        />
                                        <Button
                                            sx={{
                                                width: '20%',
                                                height: '56px',
                                                marginBottom: '12px',
                                                backgroundColor: 'var(--primary-color)',
                                                '&:hover': { backgroundColor: 'var(--primary-color)' }
                                            }}
                                            variant="contained"
                                            onClick={() => addNewInCategory("subcateory")}
                                        >
                                            Add Sub Category
                                        </Button>
                                    </div>
                                    {categoryInfo?.subCat && categoryInfo?.subCat?.length > 0 &&
                                        categoryInfo?.subCat?.map((item, index) => (
                                            <div
                                                key={index}
                                                style={{ display: 'inline-block' }}
                                            >
                                                <div 
                                                    style={{
                                                        display: 'flex',
                                                        marginRight: '12px',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <p>{item}</p>
                                                    <button
                                                        type="button"
                                                        style={{
                                                            border: 'none',
                                                            display: 'flex',
                                                            cursor: 'pointer',
                                                            background: 'none'
                                                            
                                                        }}
                                                        onClick={() => removeCategoryInfo(item, "subcateory")}
                                                    >    
                                                        <ClearIcon sx={{ fontSize: '20px' }}/>
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                                <div
                                    style={{
                                        padding: '12px',
                                        marginTop: '16px',
                                        border: '1px solid',
                                        borderRadius: '4px'
                                    }}
                                >
                                    <InputLabel className={classes.formInputLabel}>
                                        Add New Degree Or Course
                                    </InputLabel>
                                    <div 
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <Select
                                            sx={{
                                                width: '78%',
                                                border: 'none',
                                                height: '56px',
                                                marginRight: '12px',
                                                position: 'relative',
                                                textTransform: 'capitalize'
                                            }}
                                            displayEmpty
                                            name="degree"
                                            value={courseOrDegree}
                                            onChange={handleChange}
                                            className="select-class"
                                        >
                                            <MenuItem value="">
                                                Select Degree or Course
                                            </MenuItem>
                                            {availableCourses && availableCourses.map((item, index) => (
                                                <MenuItem
                                                    value={item?.name}
                                                    key={`${index}${item?.name}`}
                                                    sx={{textTransform: 'capitalize'}}
                                                >
                                                    {item?.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {/* <TextField
                                            type="text"
                                            name="sub-category"
                                            variant="outlined"
                                            sx={{
                                                width: '78%',
                                                height: '62px'
                                            }}
                                            value={subCategoryValue}
                                            onChange={handleInputChange}
                                        /> */}
                                        <Button
                                            sx={{
                                                width: '20%',
                                                height: '56px',
                                                marginBottom: '12px',
                                                backgroundColor: 'var(--primary-color)',
                                                '&:hover': { backgroundColor: 'var(--primary-color)' }
                                            }}
                                            variant="contained"
                                            onClick={() => addNewInCategory("degree")}
                                        >
                                            Add Degree Or Course
                                        </Button>
                                    </div>
                                    {categoryInfo?.degree && categoryInfo?.degree?.length > 0 &&
                                        categoryInfo?.degree?.map((item, index) => (
                                            <div
                                                key={index}
                                                style={{ display: 'inline-block' }}
                                            >
                                                <div 
                                                    style={{
                                                        display: 'flex',
                                                        marginRight: '12px',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <p>{item}</p>
                                                    <Button
                                                        type="button"
                                                        sx={{
                                                            border: 'none',
                                                            display: 'flex',
                                                            cursor: 'pointer',
                                                            background: 'none'
                                                        }}
                                                        onClick={() => removeCategoryInfo(item, "degree")}
                                                    >    
                                                        <ClearIcon sx={{ fontSize: '20px' }}/>
                                                    </Button>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                                <Button
                                    sx={{
                                        width: '20%',
                                        height: '56px',
                                        float: 'right',
                                        display: 'flex',
                                        marginTop: '8px',
                                        marginBottom: '12px',
                                        backgroundColor: 'var(--primary-color)',
                                        '&:hover': { backgroundColor: 'var(--primary-color)' }
                                    }}
                                    variant="contained"
                                    disabled={submitLoader}
                                    onClick={() => submit("category")}
                                >
                                    {submitLoader ? <LoaderIcon />  : 'Submit' }
                                </Button>
                            </>
                        }
                    </div>
                </>
            }
            {formInformation?.configuration_type === "coaching_category" &&
                <>
                    <div
                        style={{
                            width: '100%',
                            marginTop: '12px',
                            marginRight: '12px',
                            position: 'relative',
                        }}
                    >
                        <InputLabel className={classes.formInputLabel}>
                            Select Category
                        </InputLabel>
                        <Select
                            sx={{
                                width: '100%',
                                border: 'none',
                                height: '56px',
                                marginRight: '12px',
                                position: 'relative',
                                textTransform: 'capitalize'
                            }}
                            displayEmpty
                            name="category"
                            onChange={handleChange}
                            className="select-class"
                            value={categoryInfo?.cat}
                        >
                            <MenuItem value="">
                                Select Category
                            </MenuItem>
                            {formInformation.data.map((item, index) => (
                                <MenuItem
                                    value={item?.cat}
                                    key={`${index}${item?.cat}`}
                                    sx={{textTransform: 'capitalize'}}
                                >
                                    {item?.cat}
                                </MenuItem>
                            ))}
                        </Select>
                        {!isEmpty(categoryInfo) &&
                            <>
                                <div
                                    style={{
                                        padding: '12px',
                                        marginTop: '16px',
                                        border: '1px solid',
                                        borderRadius: '4px'
                                    }}
                                >
                                    <InputLabel className={classes.formInputLabel}>
                                        Add New City
                                    </InputLabel>
                                    <div 
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        {/* <TextField
                                            type="text"
                                            name="new-city-co"
                                            variant="outlined"
                                            sx={{
                                                width: '78%',
                                                height: '62px'
                                            }}
                                            value={cityValueCoachingCat}
                                            onChange={handleInputChange}
                                        /> */}
                                        
                                        <Select
                                            sx={{
                                                width: '78%',
                                                border: 'none',
                                                height: '56px',
                                                marginRight: '12px',
                                                position: 'relative',
                                                textTransform: 'capitalize'
                                            }}
                                            displayEmpty
                                            name="city-co"
                                            onChange={handleChange}
                                            className="select-class"
                                            value={cityValueCoachingCat}
                                        >
                                            <MenuItem value="">
                                                Select City
                                            </MenuItem>
                                            {configData && configData?.length > 0 &&
                                                configData?.map((item, index) => (
                                                item?.configuration_type === "city" &&
                                                item?.data?.map((it) => (
                                                    <MenuItem
                                                        value={it}
                                                        key={`${index}${it}`}
                                                        sx={{textTransform: 'capitalize'}}
                                                    >
                                                        {it}
                                                    </MenuItem>
                                                ))
                                            ))}
                                        </Select>
                                        <Button
                                            sx={{
                                                width: '20%',
                                                height: '56px',
                                                marginBottom: '12px',
                                                backgroundColor: 'var(--primary-color)',
                                                '&:hover': { backgroundColor: 'var(--primary-color)' }
                                            }}
                                            variant="contained"
                                            onClick={() => addNewInCategory("city-co")}
                                        >
                                            Add City
                                        </Button>
                                    </div>
                                    {categoryInfo?.city && categoryInfo?.city?.length > 0 &&
                                        categoryInfo?.city?.map((item, index) => (
                                            <div
                                                key={index}
                                                style={{ display: 'inline-block' }}
                                            >
                                                <div 
                                                    style={{
                                                        display: 'flex',
                                                        marginRight: '12px',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <p>{item}</p>
                                                    <button
                                                        type="button"
                                                        style={{
                                                            border: 'none',
                                                            display: 'flex',
                                                            cursor: 'pointer',
                                                            background: 'none'
                                                            
                                                        }}
                                                        onClick={() => removeCategoryInfo(item, "city-co")}
                                                    >    
                                                        <ClearIcon sx={{ fontSize: '20px' }}/>
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                                {/* <div
                                    style={{
                                        padding: '12px',
                                        marginTop: '16px',
                                        border: '1px solid',
                                        borderRadius: '4px'
                                    }}
                                >
                                    <InputLabel className={classes.formInputLabel}>
                                        Add New Sub Category
                                    </InputLabel>
                                    <div 
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <TextField
                                            type="text"
                                            name="sub-category"
                                            variant="outlined"
                                            sx={{
                                                width: '78%',
                                                height: '62px'
                                            }}
                                            value={subCategoryValue}
                                            onChange={handleInputChange}
                                        />
                                        <Button
                                            sx={{
                                                width: '20%',
                                                height: '56px',
                                                marginBottom: '12px',
                                                backgroundColor: 'var(--primary-color)',
                                                '&:hover': { backgroundColor: 'var(--primary-color)' }
                                            }}
                                            variant="contained"
                                            onClick={() => addNewInCategory("subcateory")}
                                        >
                                            Add Sub Category
                                        </Button>
                                    </div>
                                    {categoryInfo?.subCat && categoryInfo?.subCat?.length > 0 &&
                                        categoryInfo?.subCat?.map((item, index) => (
                                            <div
                                                key={index}
                                                style={{ display: 'inline-block' }}
                                            >
                                                <div 
                                                    style={{
                                                        display: 'flex',
                                                        marginRight: '12px',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <p>{item}</p>
                                                    <button
                                                        type="button"
                                                        style={{
                                                            border: 'none',
                                                            display: 'flex',
                                                            cursor: 'pointer',
                                                            background: 'none'
                                                            
                                                        }}
                                                        onClick={() => removeCategoryInfo(item, "subcateory")}
                                                    >    
                                                        <ClearIcon sx={{ fontSize: '20px' }}/>
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div> */}
                                <div
                                    style={{
                                        padding: '12px',
                                        marginTop: '16px',
                                        border: '1px solid',
                                        borderRadius: '4px'
                                    }}
                                >
                                    <InputLabel className={classes.formInputLabel}>
                                        Add New Exam
                                    </InputLabel>
                                    <div 
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <Select
                                            sx={{
                                                width: '78%',
                                                border: 'none',
                                                height: '56px',
                                                marginRight: '12px',
                                                position: 'relative',
                                                textTransform: 'capitalize'
                                            }}
                                            name="exam"
                                            displayEmpty
                                            value={selectedExam}
                                            onChange={handleChange}
                                            className="select-class"
                                        >
                                            <MenuItem value="">
                                                Select Exam
                                            </MenuItem>
                                            {availableExams && availableExams.map((item, index) => (
                                                <MenuItem
                                                    value={item?.name}
                                                    key={`${index}${item?.name}`}
                                                    sx={{textTransform: 'capitalize'}}
                                                >
                                                    {item?.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {/* <TextField
                                            type="text"
                                            name="sub-category"
                                            variant="outlined"
                                            sx={{
                                                width: '78%',
                                                height: '62px'
                                            }}
                                            value={subCategoryValue}
                                            onChange={handleInputChange}
                                        /> */}
                                        <Button
                                            sx={{
                                                width: '20%',
                                                height: '56px',
                                                marginBottom: '12px',
                                                backgroundColor: 'var(--primary-color)',
                                                '&:hover': { backgroundColor: 'var(--primary-color)' }
                                            }}
                                            variant="contained"
                                            onClick={() => addNewInCategory("exam")}
                                        >
                                            Add Exam
                                        </Button>
                                    </div>
                                    {categoryInfo?.exams && categoryInfo?.exams?.length > 0 &&
                                        categoryInfo?.exams?.map((item, index) => (
                                            <div
                                                key={index}
                                                style={{ display: 'inline-block' }}
                                            >
                                                <div 
                                                    style={{
                                                        display: 'flex',
                                                        marginRight: '12px',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <p>{item}</p>
                                                    <Button
                                                        type="button"
                                                        sx={{
                                                            border: 'none',
                                                            display: 'flex',
                                                            cursor: 'pointer',
                                                            background: 'none'
                                                        }}
                                                        onClick={() => removeCategoryInfo(item, "exam")}
                                                    >    
                                                        <ClearIcon sx={{ fontSize: '20px' }}/>
                                                    </Button>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                                <Button
                                    sx={{
                                        width: '20%',
                                        height: '56px',
                                        float: 'right',
                                        display: 'flex',
                                        marginTop: '8px',
                                        marginBottom: '12px',
                                        backgroundColor: 'var(--primary-color)',
                                        '&:hover': { backgroundColor: 'var(--primary-color)' }
                                    }}
                                    variant="contained"
                                    disabled={submitLoader}
                                    onClick={() => submit("coaching_category")}
                                >
                                    {submitLoader ? <LoaderIcon />  : 'Submit' }
                                </Button>
                            </>
                        }
                    </div>
                </>
            }
            {formInformation?.configuration_type === "city" &&
                <div
                    style={{
                        padding: '12px',
                        marginTop: '16px',
                        border: '1px solid',
                        borderRadius: '4px'
                    }}
                >
                    <InputLabel className={classes.formInputLabel}>
                        Add New City
                    </InputLabel>
                    <div 
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <TextField
                            type="text"
                            variant="outlined"
                            sx={{
                                width: '78%',
                                height: '62px'
                            }}
                            name="new-coaching-city"
                            value={coachingCityValue}
                            onChange={handleInputChange}
                        />
                        <Button
                            sx={{
                                width: '20%',
                                height: '56px',
                                marginBottom: '12px',
                                backgroundColor: 'var(--primary-color)',
                                '&:hover': { backgroundColor: 'var(--primary-color)' }
                            }}
                            variant="contained"
                            disabled={submitLoader}
                            onClick={() => submit("coaching_city")}
                        >
                            {submitLoader ? <LoaderIcon />  : 'Submit' }
                        </Button>
                    </div>
                    {formInformation?.data && formInformation?.data?.length > 0 &&
                        formInformation?.data?.map((item, index) => (
                            <div
                                key={index}
                                style={{ display: 'inline-block' }}
                            >
                                <div 
                                    style={{
                                        display: 'flex',
                                        marginRight: '12px',
                                        alignItems: 'center'
                                    }}
                                >
                                    <p>{item}</p>
                                    <button
                                        type="button"
                                        style={{
                                            border: 'none',
                                            display: 'flex',
                                            cursor: 'pointer',
                                            background: 'none'
                                        }}
                                        onClick={() => removeCategoryInfo(item, "coaching-city")}
                                    >    
                                        <ClearIcon sx={{ fontSize: '20px' }}/>
                                    </button>
                                </div>
                            </div>
                        ))
                    }
                </div>
            }
        </div>
    );
};

export default ConfigList;